import dayjs from "dayjs";

/**
 * The compact relative form the design uses: "5m ago", "1h ago", "2d ago", "2w ago".
 *
 * dayjs's relativeTime plugin would say "5 minutes ago", which does not fit the card, so this is
 * written out. Invalid and zero dates return an em dash rather than "Invalid Date" — the
 * projects table carried `0000-00-00` values until the Phase 1 migration backfilled them, and
 * other tables still can.
 */
export const formatRelativeTime = (value) => {
  if (!value) return "—";

  const date = dayjs(value);

  if (!date.isValid() || date.year() < 1970) return "—";

  const seconds = Math.max(dayjs().diff(date, "second"), 0);

  if (seconds < 60) return "just now";

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;

  const weeks = Math.floor(days / 7);
  if (days < 30) return `${weeks}w ago`;

  const months = Math.floor(days / 30);
  if (days < 365) return `${months}mo ago`;

  return `${Math.floor(days / 365)}y ago`;
};

/** "30 Aug, 2026" — the Date created column in both detail tables. */
export const formatDate = (value) => {
  if (!value) return "—";

  const date = dayjs(value);

  if (!date.isValid() || date.year() < 1970) return "—";

  return date.format("D MMM, YYYY");
};

/** "Last modified 25 mins ago" — the detail page's header line. */
export const formatLastModified = (value) => {
  const relative = formatRelativeTime(value);
  return relative === "—" ? "" : `Last modified ${relative.replace(/^(\d+)m ago$/, "$1 mins ago")}`;
};
